import { render, staticRenderFns } from "./WizardNavigator.vue?vue&type=template&id=2fe3fa82&scoped=true"
import script from "./WizardNavigator.vue?vue&type=script&lang=js"
export * from "./WizardNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe3fa82",
  null
  
)

export default component.exports